import React from 'react';
import {
    Box,
    Typography,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
} from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import NoDocumentsPdf from '../../../assests/pdf/NoDocument.pdf';
import NoDocumentScanned from '../../../assests/images/svgs/NoDocumentScanned.svg';
import bankIcon from '../../../assests/images/bank-icon.png';
import creditCardIcon from '../../../assests/images/credit-card-icon.png';
import checkIcon from '../../../assests/images/check-icon.png';
import cashIcon from '../../../assests/images/cash-icon.png';

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};

const headerStyle = {
    backgroundColor: '#E3E7FE',
    color: '#1222b3',
    textAlign: 'left',
    leadingTrim: 'both',
    textEdge: 'cap',
    fontFamily: 'Montserrat',
    fontSize: 'var(--xtram-grid-header-font, 13px)',
    fontStyle: 'normal',
    fontWeight: 'bold',
    lineHeight: 'normal',
    height: '40px',
    minHeight: '36px',
    padding: '1px 3px',
};

/**
 * Nested payment tables shown when a Payment Acceptance row is expanded.
 * Kept as plain MUI Tables (not DataGrid) to preserve existing layout.
 */
const PaymentAcceptanceExpandPanel = ({
    row,
    t,
    accountCardMap,
    openPdfInNewTab,
    handleDownloadDocument,
    getAlignment,
}) => {
    if (!row) return null;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                padding: '4px',
                maxWidth: '85%',
                minWidth: 0,
            }}
        >
        {/* Checks */}
        {(row.checks?.length > 0) && (
            <Box sx={{ margin: 0.5, marginInlineEnd: 20, padding: 1, backgroundColor: '#f8f9fa', borderRadius: '4px' }} dir="rtl">
                <Typography
                    variant="h6"
                    gutterBottom
                    component="div"
                    className='main-title'
                    sx={{ fontSize: 'var(--xtram-text-md, 1rem)', fontWeight: 'bold', marginBottom: '8px', color: '#304FFF' , textAlign: 'left'}}
                >
                    {t('Checks')}
                </Typography>
                <Typography
                    variant="body2"
                    gutterBottom
                    component="div"
                    sx={{ fontSize: 'var(--xtram-text-xs, 0.75rem)', fontWeight: '600', textAlign: 'left', marginBottom: '6px', color: '#666' }}
                >
                    {row.paymentAcceptanceType === 'תקבול'
                        ? `${t('TotalDebitAccount')}: ${row.checks.reduce(
                            (total, check) => total + check.amount,
                            0
                        )} (${t('Debit Account')}: ${accountCardMap[row.checks[0].debitAccount] || ''})`
                        : `${t('TotalCreditAccount')}: ${row.checks.reduce(
                            (total, check) => total + check.amount,
                            0
                        )} (${t('Credit Account')}: ${accountCardMap[row.checks[0].creditAccount] || ''})`}
                </Typography>
                <Table size="small" aria-label="purchases" sx={{ 
                    '& .MuiTableCell-root': {
                        padding: '6px 8px',
                        fontSize: 'var(--xtram-panel-head, 11px)',
                        height: 'var(--xtram-grid-row-height, 40px)',
                        minHeight: 'var(--xtram-grid-row-height, 40px)',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    },
                    '& .MuiTableRow-root': {
                        height: 'var(--xtram-grid-row-height, 40px)',
                        minHeight: 'var(--xtram-grid-row-height, 40px)'
                    }
                }}>
                    <TableHead>
                        <TableRow>
                            {/* Checks Table Headers */}
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('date')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('CheckNumber')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('amount')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('supplierAccountNumber')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('bankName')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Reference2')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Debit Account')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Credit Account')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Document')}
                            </TableCell>
                            {/* <TableCell  >
                                <IconButton onClick={() => handleEdit(row, { type: 'checks', index: -1 })}>
                                    <img src={editIcon} alt="Edit" />
                                </IconButton>
                            </TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {row.checks.map((check) => (
                            <TableRow key={check.paymentDate}>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {formatDate(check.paymentDate)}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {check.description}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {check.amount}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {check.supplierAccountNumber}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {check.bankName}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {check.reference2}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {accountCardMap[check.debitAccount] || ''}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {accountCardMap[check.creditAccount] || ''}
                                </TableCell>

                                <TableCell
                                    className="pdf-td-payment-acceptance"
                                    style={{ position: 'relative' }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        <div 
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => openPdfInNewTab(check.documentUrl)}
                                        >
                                            {check.documentUrl ? (
                                                <>
                                                    <div className="iframe-overlay-payment-acceptance"></div>
                                                    <iframe
                                                        src={
                                                            check.documentUrl
                                                                ? `${check.documentUrl}#page=1`
                                                                : `${NoDocumentScanned}#page=1`
                                                        }
                                                        className="table-pdf"
                                                        title={check.title}
                                                        style={{ 
                                                            pointerEvents: 'none', 
                                                            height: '80px', 
                                                            width: '80px', 
                                                            objectFit: 'contain',
                                                            borderRadius: '2px',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                            backgroundColor: '#f8f9fa'
                                                        }}
                                                    ></iframe>
                                                </>
                                            ) : (
                                                <img
                                                    src={checkIcon}
                                                    alt="Check Icon"
                                                    style={{ 
                                                        height: '50px', 
                                                        width: '50px', 
                                                        objectFit: 'contain',
                                                        borderRadius: '2px',
                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                        backgroundColor: '#f8f9fa',
                                                        padding: '1px'
                                                    }}
                                                />
                                            )}
                                        </div>
                                        {check.documentUrl && check.documentUrl !== NoDocumentsPdf && handleDownloadDocument && (
                                            <IconButton
                                                size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDownloadDocument(check.documentUrl, `check_${check.description || check.paymentDate}`);
                                                }}
                                                sx={{
                                                    padding: '4px',
                                                    color: '#009688',
                                                    '&:hover': {
                                                        backgroundColor: '#e0f2f1',
                                                        color: '#00796b',
                                                    }
                                                }}
                                            >
                                                <DownloadIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
        )}

        {/* Credit Cards */}
        {(row.creditCards?.length > 0) && (
            <Box sx={{ margin: 0.5, marginInlineEnd: 20, padding: 1, backgroundColor: '#f8f9fa', borderRadius: '4px' }} dir="rtl">
                <Typography
                    variant="h6"
                    gutterBottom
                    component="div"
                    className='main-title'
                    sx={{ fontSize: 'var(--xtram-text-md, 1rem)', fontWeight: 'bold', marginBottom: '8px', color: '#304FFF' , textAlign: 'left'}}
                >
                    {t('creditCards')}
                </Typography>
                <Typography
                    variant="body2"
                    gutterBottom
                    component="div"
                    sx={{ fontSize: 'var(--xtram-text-xs, 0.75rem)', fontWeight: '600', textAlign: 'left', marginBottom: '6px', color: '#666' }}
                >
                    {row.paymentAcceptanceType === 'תקבול'
                        ? `${t('TotalDebitAccount')}: ${row.creditCards.reduce(
                            (total, card) => total + card.amount,
                            0
                        )} (${t('Debit Account')}: ${accountCardMap[row.creditCards[0].debitAccount] || ''})`
                        : `${t('TotalCreditAccount')}: ${row.creditCards.reduce(
                            (total, card) => total + card.amount,
                            0
                        )} (${t('Credit Account')}: ${accountCardMap[row.creditCards[0].creditAccount] || ''})`}
                </Typography>
                <Table size="small" aria-label="purchases" sx={{ 
                    '& .MuiTableCell-root': {
                        padding: '6px 8px',
                        fontSize: 'var(--xtram-panel-head, 11px)',
                        height: 'var(--xtram-grid-row-height, 40px)',
                        minHeight: 'var(--xtram-grid-row-height, 40px)',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    },
                    '& .MuiTableRow-root': {
                        height: 'var(--xtram-grid-row-height, 40px)',
                        minHeight: 'var(--xtram-grid-row-height, 40px)'
                    }
                }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('date')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('amount')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Reference2')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Description')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Debit Account')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Credit Account')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Document')}
                            </TableCell>
                            {/* <TableCell  >
                                <IconButton onClick={() => handleEdit(row, { type: 'creditCards', index: -1 })}>
                                    <img src={editIcon} alt="Edit" />
                                </IconButton>
                            </TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {row.creditCards.map((creditCard) => (
                            <TableRow key={creditCard.amount}>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {formatDate(creditCard.paymentDate)}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {creditCard.amount}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {creditCard.description}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {creditCard.reference2}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {accountCardMap[creditCard.debitAccount] || ''}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {accountCardMap[creditCard.creditAccount] || ''}
                                </TableCell>
                                <TableCell
                                    className="pdf-td-payment-acceptance"
                                    style={{ position: 'relative' }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        <div 
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => openPdfInNewTab(creditCard.documentUrl)}
                                        >
                                            {creditCard.documentUrl ? (
                                                <>
                                                    <div className="iframe-overlay-payment-acceptance"></div>
                                                    <iframe
                                                        src={
                                                            creditCard.documentUrl
                                                                ? `${creditCard.documentUrl}#page=1`
                                                                : `${NoDocumentScanned}#page=1`
                                                        }
                                                        className="table-pdf"
                                                        title={creditCard.description}
                                                        style={{ 
                                                            pointerEvents: 'none', 
                                                            height: '80px', 
                                                            width: '80px', 
                                                            objectFit: 'contain',
                                                            borderRadius: '2px',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                            backgroundColor: '#f8f9fa'
                                                        }}
                                                    ></iframe>
                                                </>
                                            ) : (
                                                <img
                                                    src={creditCardIcon}
                                                    alt="Credit Card Icon"
                                                    style={{ 
                                                        height: '50px', 
                                                        width: '50px', 
                                                        objectFit: 'contain',
                                                        borderRadius: '2px',
                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                        backgroundColor: '#f8f9fa',
                                                        padding: '1px'
                                                    }}
                                                />
                                            )}
                                        </div>
                                        {creditCard.documentUrl && creditCard.documentUrl !== NoDocumentsPdf && handleDownloadDocument && (
                                            <IconButton
                                                size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDownloadDocument(creditCard.documentUrl, `creditcard_${creditCard.description || creditCard.paymentDate}`);
                                                }}
                                                sx={{
                                                    padding: '4px',
                                                    color: '#009688',
                                                    '&:hover': {
                                                        backgroundColor: '#e0f2f1',
                                                        color: '#00796b',
                                                    }
                                                }}
                                            >
                                                <DownloadIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
        )}

        {/* Cash */}
        {(row.cash?.length > 0) && (
            <Box sx={{ margin: 0.5, marginInlineEnd: 20, padding: 1, backgroundColor: '#f8f9fa', borderRadius: '4px' }} dir="rtl">
                <Typography
                    variant="h6"
                    gutterBottom
                    component="div"
                    className='main-title'
                    sx={{ fontSize: 'var(--xtram-text-md, 1rem)', fontWeight: 'bold', marginBottom: '8px', color: '#304FFF' , textAlign: 'left'}}
                >
                    {t('cash')}
                </Typography>
                <Typography
                    variant="body2"
                    gutterBottom
                    component="div"
                    sx={{ fontSize: 'var(--xtram-text-xs, 0.75rem)', fontWeight: '600', textAlign: 'left', marginBottom: '6px', color: '#666' }}
                >
                    {row.paymentAcceptanceType === 'תקבול'
                        ? `${t('TotalDebitAccount')}: ${row.cash.reduce(
                            (total, cash) => total + cash.amount,
                            0
                        )} (${t('Debit Account')}: ${accountCardMap[row.cash[0].debitAccount] || ''})`
                        : `${t('TotalCreditAccount')}: ${row.cash.reduce(
                            (total, cash) => total + cash.amount,
                            0
                        )} (${t('Credit Account')}: ${accountCardMap[row.cash[0].creditAccount] || ''})`}
                </Typography>
                <Table size="small" aria-label="purchases" sx={{ 
                    '& .MuiTableCell-root': {
                        padding: '6px 8px',
                        fontSize: 'var(--xtram-panel-head, 11px)',
                        height: 'var(--xtram-grid-row-height, 40px)',
                        minHeight: 'var(--xtram-grid-row-height, 40px)',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    },
                    '& .MuiTableRow-root': {
                        height: 'var(--xtram-grid-row-height, 40px)',
                        minHeight: 'var(--xtram-grid-row-height, 40px)'
                    }
                }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('date')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('amount')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Description')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Reference2')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Debit Account')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Credit Account')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Document')}
                            </TableCell>
                            {/* <TableCell  >
                                <IconButton onClick={() => handleEdit(row, { type: 'cash', index: -1 })}>
                                    <img src={editIcon} alt="Edit" />
                                </IconButton>
                            </TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {row.cash.map((cashses) => (
                            <TableRow key={cashses.amount}>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {formatDate(cashses.paymentDate)}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {cashses.amount}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {cashses.description}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {cashses.reference2}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {accountCardMap[cashses.debitAccount] || ''}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {accountCardMap[cashses.creditAccount] || ''}
                                </TableCell>
                                <TableCell
                                    className="pdf-td-payment-acceptance"
                                    style={{ position: 'relative' }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        <div 
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => openPdfInNewTab(cashses.documentUrl)}
                                        >
                                            {cashses.documentUrl ? (
                                                <>
                                                    <div className="iframe-overlay-payment-acceptance"></div>
                                                    <iframe
                                                        src={
                                                            cashses.documentUrl
                                                                ? `${cashses.documentUrl}#page=1`
                                                                : `${NoDocumentScanned}#page=1`
                                                        }
                                                        className="table-pdf"
                                                        title={cashses.description}
                                                        style={{ 
                                                            pointerEvents: 'none', 
                                                            height: '80px', 
                                                            width: '80px', 
                                                            objectFit: 'contain',
                                                            borderRadius: '2px',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                            backgroundColor: '#f8f9fa'
                                                        }}
                                                    ></iframe>
                                                </>
                                            ) : (
                                                <img
                                                    src={cashIcon}
                                                    alt="Cash Icon"
                                                    style={{ 
                                                        height: '50px', 
                                                        width: '50px', 
                                                        objectFit: 'contain',
                                                        borderRadius: '2px',
                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                        backgroundColor: '#f8f9fa',
                                                        padding: '1px'
                                                    }}
                                                />
                                            )}
                                        </div>
                                        {cashses.documentUrl && cashses.documentUrl !== NoDocumentsPdf && handleDownloadDocument && (
                                            <IconButton
                                                size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDownloadDocument(cashses.documentUrl, `cash_${cashses.description || cashses.paymentDate}`);
                                                }}
                                                sx={{
                                                    padding: '4px',
                                                    color: '#009688',
                                                    '&:hover': {
                                                        backgroundColor: '#e0f2f1',
                                                        color: '#00796b',
                                                    }
                                                }}
                                            >
                                                <DownloadIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
        )}

        {/* Bank Transactions */}
        {(row.bankTransactions?.length > 0) && (
            <Box sx={{ margin: 0.5, marginInlineEnd: 20, padding: 1, backgroundColor: '#f8f9fa', borderRadius: '4px' }} dir="rtl">
                <Typography
                    variant="h6"
                    gutterBottom
                    component="div"
                    className='main-title'
                    sx={{ fontSize: 'var(--xtram-text-md, 1rem)', fontWeight: 'bold', marginBottom: '8px', color: '#304FFF' , textAlign: 'left'}}
                >
                    {t('bankTransactions')}
                </Typography>

                {/* Grouped Totals */}
                {row.paymentAcceptanceType === 'תקבול'
                    ? Object.values(
                        row.bankTransactions.reduce((acc, bankTransaction) => {
                            if (!acc[bankTransaction.debitAccount]) {
                                acc[bankTransaction.debitAccount] = [];
                            }
                            acc[bankTransaction.debitAccount].push(bankTransaction);
                            return acc;
                        }, {})
                    ).map((group) => (
                        <Typography
                            variant="body2"
                            gutterBottom
                            component="div"
                            sx={{ fontSize: 'var(--xtram-text-xs, 0.75rem)', fontWeight: '600', textAlign: 'left', marginBottom: '4px', color: '#666' }}
                        >
                            {`${t('TotalDebitAccount')}: ${group.reduce(
                                (total, bankTransaction) => total + bankTransaction.amount,
                                0
                            )} (${t('Debit Account')}: ${accountCardMap[group[0].debitAccount] || ''})`}
                        </Typography>
                    ))
                    : Object.values(
                        row.bankTransactions.reduce((acc, bankTransaction) => {
                            if (!acc[bankTransaction.creditAccount]) {
                                acc[bankTransaction.creditAccount] = [];
                            }
                            acc[bankTransaction.creditAccount].push(bankTransaction);
                            return acc;
                        }, {})
                    ).map((group) => (
                        <Typography
                            variant="body2"
                            gutterBottom
                            component="div"
                            sx={{ fontSize: 'var(--xtram-text-xs, 0.75rem)', fontWeight: '600', textAlign: 'left', marginBottom: '4px', color: '#666' }}
                        >
                            {`${t('TotalCreditAccount')}: ${group.reduce(
                                (total, bankTransaction) => total + bankTransaction.amount,
                                0
                            )} (${t('Credit Account')}: ${accountCardMap[group[0].creditAccount] || ''})`}
                        </Typography>
                    ))}

                <Table size="small" aria-label="purchases" sx={{ 
                    '& .MuiTableCell-root': {
                        padding: '6px 8px',
                        fontSize: 'var(--xtram-panel-head, 11px)',
                        height: 'var(--xtram-grid-row-height, 40px)',
                        minHeight: 'var(--xtram-grid-row-height, 40px)',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    },
                    '& .MuiTableRow-root': {
                        height: 'var(--xtram-grid-row-height, 40px)',
                        minHeight: 'var(--xtram-grid-row-height, 40px)'
                    }
                }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('date')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('amount')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Description')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Reference2')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Debit Account')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Credit Account')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Document')}
                            </TableCell>
                            {/* <TableCell  >
                                <IconButton onClick={() => handleEdit(row, { type: 'bankTransactions', index: -1 })}>
                                    <img src={editIcon} alt="Edit" />
                                </IconButton>
                            </TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {row.bankTransactions.map((bankTransaction) => (
                            <TableRow key={bankTransaction.amount}>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {formatDate(bankTransaction.paymentDate)}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {bankTransaction.amount}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {bankTransaction.description}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {bankTransaction.reference2}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {accountCardMap[bankTransaction.debitAccount] || ''}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {accountCardMap[bankTransaction.creditAccount] || ''}
                                </TableCell>
                                <TableCell 
                                    className="pdf-td-payment-acceptance"
                                    style={{ position: 'relative' }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        <div 
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => openPdfInNewTab(bankTransaction.documentUrl)}
                                        >
                                            {bankTransaction.documentUrl ? (
                                                <>
                                                    <div className="iframe-overlay-payment-acceptance"></div>
                                                    <iframe
                                                        src={
                                                            bankTransaction.documentUrl
                                                                ? `${bankTransaction.documentUrl}#page=1`
                                                                : `${NoDocumentScanned}#page=1`
                                                        }
                                                        className="table-pdf"
                                                        title={bankTransaction.description}
                                                        style={{ 
                                                            pointerEvents: 'none', 
                                                            height: '80px', 
                                                            width: '80px', 
                                                            objectFit: 'contain',
                                                            borderRadius: '2px',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                            backgroundColor: '#f8f9fa'
                                                        }}
                                                    ></iframe>
                                                </>
                                            ) : (
                                                <img
                                                    src={bankIcon}
                                                    alt="Bank Icon"
                                                    style={{ 
                                                        height: '50px', 
                                                        width: '50px', 
                                                        objectFit: 'contain',
                                                        borderRadius: '2px',
                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                        backgroundColor: '#f8f9fa',
                                                        padding: '1px'
                                                    }}
                                                />
                                            )}
                                        </div>
                                        {bankTransaction.documentUrl && bankTransaction.documentUrl !== NoDocumentsPdf && handleDownloadDocument && (
                                            <IconButton
                                                size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDownloadDocument(bankTransaction.documentUrl, `banktransaction_${bankTransaction.description || bankTransaction.paymentDate}`);
                                                }}
                                                sx={{
                                                    padding: '4px',
                                                    color: '#009688',
                                                    '&:hover': {
                                                        backgroundColor: '#e0f2f1',
                                                        color: '#00796b',
                                                    }
                                                }}
                                            >
                                                <DownloadIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
        )}

        {/* Offsets */}
        {row.offsets && row.offsets.length > 0 && (
            <Box sx={{ margin: 0.5, marginInlineEnd: 20, padding: 1, backgroundColor: '#f8f9fa', borderRadius: '4px' }} dir="rtl">
                <Typography
                    variant="h6"
                    gutterBottom
                    component="div"
                    className='main-title'
                    sx={{ fontSize: 'var(--xtram-text-md, 1rem)', fontWeight: 'bold', marginBottom: '8px', color: '#304FFF' , textAlign: 'left'}}
                >
                    {t('offsets')}
                </Typography>
                <Typography
                    variant="body2"
                    gutterBottom
                    component="div"
                    sx={{ fontSize: 'var(--xtram-text-xs, 0.75rem)', fontWeight: '600', textAlign: 'left', marginBottom: '6px', color: '#666' }}
                >
                    {row.paymentAcceptanceType === 'תקבול'
                        ? `${t('TotalDebitAccount')}: ${row.offsets.reduce(
                            (total, offset) => total + offset.amount,
                            0
                        )} (${t('Debit Account')}: ${accountCardMap[row.offsets[0].debitAccount] || ''})`
                        : `${t('TotalCreditAccount')}: ${row.offsets.reduce(
                            (total, offset) => total + offset.amount,
                            0
                        )} (${t('Credit Account')}: ${accountCardMap[row.offsets[0].creditAccount] || ''})`}
                </Typography>
                <Table size="small" aria-label="offsets" sx={{ 
                    '& .MuiTableCell-root': {
                        padding: '6px 8px',
                        fontSize: 'var(--xtram-panel-head, 11px)',
                        height: 'var(--xtram-grid-row-height, 40px)',
                        minHeight: 'var(--xtram-grid-row-height, 40px)',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    },
                    '& .MuiTableRow-root': {
                        height: 'var(--xtram-grid-row-height, 40px)',
                        minHeight: 'var(--xtram-grid-row-height, 40px)'
                    }
                }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('date')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('amount')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Description')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Reference2')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Debit Account')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Credit Account')}
                            </TableCell>
                            <TableCell sx={headerStyle} style={{ textAlign: getAlignment() }} >
                                {t('Document')}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {row.offsets.map((offset) => (
                            <TableRow key={offset.id || offset.amount}>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {formatDate(offset.paymentDate)}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {offset.amount}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {offset.description}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {offset.reference2}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {accountCardMap[offset.debitAccount] || ''}
                                </TableCell>
                                <TableCell style={{ textAlign: getAlignment() }} >
                                    {accountCardMap[offset.creditAccount] || ''}
                                </TableCell>
                                <TableCell
                                    className="pdf-td-payment-acceptance"
                                    style={{ position: 'relative' }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        <div 
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => openPdfInNewTab(offset.documentUrl)}
                                        >
                                            {offset.documentUrl ? (
                                                <>
                                                    <div className="iframe-overlay-payment-acceptance"></div>
                                                    <iframe
                                                        src={
                                                            offset.documentUrl
                                                                ? `${offset.documentUrl}#page=1`
                                                                : `${NoDocumentScanned}#page=1`
                                                        }
                                                        className="table-pdf"
                                                        title={offset.description}
                                                        style={{ 
                                                            pointerEvents: 'none', 
                                                            height: '80px', 
                                                            width: '80px', 
                                                            objectFit: 'contain',
                                                            borderRadius: '2px',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                            backgroundColor: '#f8f9fa'
                                                        }}
                                                    ></iframe>
                                                </>
                                            ) : (
                                                <img
                                                    src={cashIcon}
                                                    alt="Offset Icon"
                                                    style={{ 
                                                        height: '50px', 
                                                        width: '50px', 
                                                        objectFit: 'contain',
                                                        borderRadius: '2px',
                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                        backgroundColor: '#f8f9fa',
                                                        padding: '1px'
                                                    }}
                                                />
                                            )}
                                        </div>
                                        {offset.documentUrl && offset.documentUrl !== NoDocumentsPdf && handleDownloadDocument && (
                                            <IconButton
                                                size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDownloadDocument(offset.documentUrl, `offset_${offset.description || offset.paymentDate}`);
                                                }}
                                                sx={{
                                                    padding: '4px',
                                                    color: '#009688',
                                                    '&:hover': {
                                                        backgroundColor: '#e0f2f1',
                                                        color: '#00796b',
                                                    }
                                                }}
                                            >
                                                <DownloadIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
        )}
        </Box>
    );
};

export default PaymentAcceptanceExpandPanel;
